import { Link } from "react-router";

import { PageHeader } from "@/shell/PageHeader";
import { Button } from "@/ui/Button";
import { EmptyState } from "@/ui/states";

export function NotFoundRoute() {
  return (
    <>
      <PageHeader title="Page not found" />
      <EmptyState
        title="That page does not exist"
        description="The address may be out of date, or the resource may not be available to your account."
        action={
          <Button variant="outline" asChild>
            <Link to="/projects">Back to Projects</Link>
          </Button>
        }
      />
    </>
  );
}
